import { convertImageUrlToBase64, convertToBase64 } from "../helpers/sharedFunctions";
import { AttachingFile } from "../interfaces/IGraduateFilterObjMsg";
import { IPreSignedUrlReq, IPresignedUrl } from "../interfaces/IPreSignedUrl";
import { getSignUrl, uploadFileSignedUrl } from "./s3Service";
import jwt from 'jsonwebtoken';




type SignatureFile = {name:string, url:string} | null

export const uploadSignature = async(file: File) =>{

    const signature:SignatureFile = await getSignature();
    if(signature){
        let results = new FormData();
        results.append('file', file, signature.name);

        await uploadFileSignedUrl(signature.url, file);
    }
}


const fileExists = async (url: string): Promise<boolean> => {
    try {
        const response = await fetch(url, { method: "GET" });
        return response.ok; // true if status is 200-299
    } catch (error) {
        console.error("Error checking file:", error);
        return false;
    }
}

export const loadSignature = async():Promise<AttachingFile | null> =>{
    const signature:SignatureFile = await getSignature("GET");
    console.log(signature?.url);
    if(signature && await fileExists(signature.url)){
        
        const base64File: any = await convertImageUrlToBase64(signature?.url);
        return {
            base64: base64File,
            type: "image/png",
            filename: "firma.png",
            previewUrl: signature?.url
        };
    }
    return null;
   }


export const getSignature = async(method:string="POST"):Promise<SignatureFile> =>{
    if (sessionStorage.getItem('Bearer')) {
        const itemProfile = sessionStorage.getItem('Bearer') ? sessionStorage.getItem('Bearer') + "" : "";
        if (jwt.decode(itemProfile)) {
            const resDecoded: any = jwt.decode(itemProfile);
            if (resDecoded) {
                const profileDecoded: any = resDecoded.message;
                const fileName: string = `firma_${profileDecoded.id}_${profileDecoded.username}.png`;            
                const fileToUpload: IPreSignedUrlReq = {
                    contentType: "image/png",
                    fileKey: fileName,
                    folderId: `firmas`,
                    description: "",
                    isPublic: true,
                  }
                const resultURL: IPresignedUrl = await getSignUrl(fileToUpload, method);
                if (resultURL) {
                    return {
                        name: fileName,
                        url: resultURL.uploadURL
                    };
                }
                return null;
            }
        }
    }
    return null;
}